import React, { Component } from "react";

class AttendanceUpSVG extends React.Component {
  render() {
    return (
      <svg
        className={"svg-container " + this.props.svgClassName}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 25 25"
      >
        <path
          className="svg"
          d="M20.2,12.2c-0.8-1.2-1.9-2.1-3.2-2.6c0.3-0.4,0.5-0.9,0.7-1.4c0.7,0.5,1.4,0.8,2.2,0.8c0.9,0,1.8-0.4,2.6-1
	c1.7,0.5,3.1,5.7,2.2,6.3c-0.1,0.1-0.3,0.2-0.4,0.3C23.3,13.3,21.8,12.5,20.2,12.2z M8,9.5C7.7,9.1,7.5,8.6,7.3,8.1
	C6.6,8.6,5.9,8.9,5.1,8.9c-0.9,0-1.8-0.4-2.6-1c-1.7,0.5-3.1,5.7-2.2,6.3c0.9,0.6,1.9,1.1,3,1.3C4,12.5,5.6,10.5,8,9.5z M5.1,7.9
	c0.7,0,1.3-0.2,1.8-0.6C6.8,6.5,6.6,5.8,6.6,5c0-1.4,0.4-2.7,1.1-3.7C7.2,0.5,6.3,0.1,5.1,0.1C0.3,0.1,0.9,7.9,5.1,7.9z M18.1,7.3
	c0.5,0.4,1.1,0.6,1.8,0.6c4.2,0,4.8-7.8,0-7.8c-1.2,0-2.1,0.5-2.6,1.2c0.7,1,1.1,2.3,1.1,3.8C18.4,5.9,18.3,6.6,18.1,7.3z
	 M12.5,10.6c5.6,0,6.4-10.5,0-10.5S6.9,10.6,12.5,10.6z M18.4,12.1c-0.7-0.6-1.4-1.1-2.4-1.4c-1.1,0.8-2.2,1.4-3.5,1.4
	s-2.4-0.6-3.5-1.4c-3,1-4.4,3.5-4.8,7c1.9,2,4.5,3.4,8,3.5c-0.2-0.6-0.3-1.3-0.3-2C11.9,15.4,14.8,12.3,18.4,12.1z M24.9,19.1
	c0-3.3-2.6-5.9-5.9-5.9S13,15.8,13,19.1S15.7,25,19,25S24.9,22.4,24.9,19.1z M24,19.1c0,2.8-2.3,5.1-5.1,5.1s-5.1-2.3-5.1-5.1
	S16.1,14,19,14S24,16.3,24,19.1z M18.7,22.5l3.7-5l-0.8-0.6l-3.2,4.4l-1.9-2.6l-0.8,0.7l2.3,3.2H18.7z"
        />
      </svg>
    );
  }
}

export default AttendanceUpSVG;



// WEBPACK FOOTER //
// ./src/svg/AttendanceUpSVG.jsx